import moment from 'moment';

/**
 * 组件渲染错错误自动刷新
 * @param error
 */
export const PAGE_ERROR_RELOAD_INFO = 'page_error_reload_info';

const RELOAD_MAX_TIME = 10; // 超过t秒自动刷新

interface IReloadInfo {
    lastReloadTime: number;
    hasReload: boolean;
    hasReloadPath: string;
    forceReload: boolean; // 是否强制刷新
}
const defaultReloadInfo: IReloadInfo = {
    lastReloadTime: 0, // 上一次刷新时间
    hasReload: false, // 是否已经刷新的标记
    hasReloadPath: '', // 刷新的页面路径
    forceReload: false, // 是否强制刷新过
};
const isLocal = location.hostname === 'localhost';
export function handleErrorReLoad(): boolean {
    const storage_reload_info = localStorage.getItem(PAGE_ERROR_RELOAD_INFO);
    // 缓存里的刷新信息
    let page_error_reload_info: IReloadInfo = storage_reload_info ? JSON.parse(storage_reload_info) : defaultReloadInfo;
    const hasReload = page_error_reload_info.hasReload;
    const lastReloadTime = Number(page_error_reload_info.lastReloadTime);
    let forceReload = page_error_reload_info.forceReload;
    // 距离上一次刷新时间是否超过10s
    const isExpired = moment(new Date().getTime()).diff(moment(lastReloadTime), 'second') > RELOAD_MAX_TIME;
    // 没有触发过自动刷新 || 距离上一次刷新时间超过10s   则自动刷新
    if (!hasReload || isExpired) {
        // 刷新页面
        if (!forceReload) {
            forceReload = true;
            !isLocal && location.reload(true); // 强制刷新一次, 获取最新的资源
        } else {
            forceReload = false;
            !isLocal && location.reload(); // 正常刷新
        }
        // 更新刷新信息
        page_error_reload_info = {
            lastReloadTime: new Date().getTime(),
            hasReload: true,
            hasReloadPath: location.pathname,
            forceReload,
        };
        // 更新缓存里的值
        localStorage.setItem(PAGE_ERROR_RELOAD_INFO, JSON.stringify(page_error_reload_info));
        return false;
    }
    // 如果是刷新过 || 距离上一次刷新时间不超过10s，提示用户联系平台负责人:即返回true
    if (hasReload || !isExpired) {
        return true;
    }
    return true;
}
